export const Country3to2CodeMap = {
  AUS: 'AU',
  NZL: 'NZ',
  USA: 'US',
  CAN: 'CA',
  GBR: 'GB',
};

export const buildAfterpayClearpayModalUrl = (countryCode3: string): string => {
  const countryCode = Country3to2CodeMap[countryCode3];

  if (!countryCode) {
    return '';
  }

  return `https://static.afterpay.com/modal/en_${countryCode}.html`;
};
